import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PaginatorModule, PaginatorState } from 'primeng/paginator';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-custom-paginator',
  standalone: true,
  imports: [CommonModule, FormsModule, PaginatorModule, TranslateModule],
  templateUrl: './custom-paginator.component.html',
  styleUrls: ['./custom-paginator.component.scss'],
})
export class CustomPaginatorComponent {
  @Input() first: number = 0;
  @Input() pageSize: number = 10;
  @Input() totalRecords: number = 0;
  @Input() rowsPerPageOptions: number[] = [10, 20, 50];

  @Output() pageChange = new EventEmitter<PaginatorState>();
  @Output() pageSizeChange = new EventEmitter<number>();

  onPageChange(event: PaginatorState): void {
    this.pageChange.emit(event);
  }

  onRowsPerPageChange(newSize: number): void {
    this.pageSizeChange.emit(newSize);
  }
}
